import { createAsyncThunk } from "@reduxjs/toolkit";
import { COREURL } from "../../constants/api_constants";
import { ApiServices } from "../../services/api_services";

const createCustomerTag = createAsyncThunk(
  "createcustomerTag",
  async (data: any) => {
    return ApiServices.post(COREURL, "/insert_customer_tag", data)
      .then((response) => response)
      .catch((error) => error);
  }
);

const getCustomerTag = createAsyncThunk("getcustomerTag", async () => {
  return ApiServices.get(COREURL, "/get_customer_tag")
    .then((response) => response)
    .catch((error) => error);
});

const updateCustomerTagSuccess = createAsyncThunk(
  "updateCustomerTag",
  async (data: any) => {
    return ApiServices.put(COREURL, `/update_customer_tag/${data.cid}`, data)
      .then((response) => response)
      .catch((error) => error);
  }
);

const isValidCustomerTag = createAsyncThunk(
  "isValidCustomerTag",
  async (data: any) => {
    return ApiServices.post(COREURL, "/is_valid_customer_tag", data)
      .then((response) => response)
      .catch((error) => error);
  }
);

const deleteCustomerTag = createAsyncThunk(
  "deleteCustomerTag",
  async (data: any) => {
    return ApiServices.delete(COREURL, `/delete_customer_tag/${data}`)
      .then((response) => response)
      .catch((error) => error);
  }
);

const isEnableCustomerTag = createAsyncThunk(
  "isEnableCustomerTag",
  async (data: any) => {
    return ApiServices.post(COREURL, "/customer_tag_disable", data)
      .then((response) => response)
      .catch((error) => error);
  }
);

export {
  createCustomerTag,
  getCustomerTag,
  updateCustomerTagSuccess,
  isValidCustomerTag,
  deleteCustomerTag,
  isEnableCustomerTag,
};
